export default ({ pageState: { editorBlocks, editorIsBlockMoveView } }) => {
  if (editorIsBlockMoveView) return { editorIsBlockMoveView: false };

  const modifiedBlocks = {};
  for (const blockId of Object.keys(editorBlocks)) {
    modifiedBlocks[blockId] = { ...editorBlocks[blockId], isSelected: false };
  }

  return { editorBlocks: modifiedBlocks };
};
